import { render, staticRenderFns } from "./TariffsOfBinaryAccount.vue?vue&type=template&id=7fe953bc&scoped=true"
import script from "./TariffsOfBinaryAccount.vue?vue&type=script&lang=js"
export * from "./TariffsOfBinaryAccount.vue?vue&type=script&lang=js"
import style0 from "./TariffsOfBinaryAccount.vue?vue&type=style&index=0&id=7fe953bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe953bc",
  null
  
)

export default component.exports